import { useQuery } from '@tanstack/react-query';
import { type UseQueryReturnType, gqlClient, graphql } from '@tyro/api';
import { shellKeys } from '../keys';

const tyroneConversationsList = graphql(/* GraphQL */ `
  query tyrone_myConversations {
    tyrone_myConversations {
      id
      partyId
      initialMessage
      createdOn
      updatedOn
    }
  }
`);

const tyroneConversationsListQuery = {
  queryKey: shellKeys.tyrone.conversations(),
  queryFn: async () => gqlClient.request(tyroneConversationsList),
};

export function useTyroneConversationsList() {
  return useQuery({
    ...tyroneConversationsListQuery,
    select: ({ tyrone_myConversations }) => tyrone_myConversations,
  });
}

export type ReturnTypeFromTyroneConversationsList = UseQueryReturnType<
  typeof useTyroneConversationsList
>[number];
